const stableTooltipOptions = {
    popperTriggers: ['hover'],
    delay: {
        show: 200,
        hide: 150,
    },
};

export function containsHtmlTags(content) {
    if (typeof content !== 'string' || !content) {
        return false;
    }

    return /<[a-z][\s\S]*>/i.test(content);
}

export function tooltipBinding(content, { html, position = 'auto' } = {}) {
    if (!content) {
        return null;
    }

    const options = {
        content,
        ...stableTooltipOptions,
    };

    if (position !== 'auto') {
        options.placement = position;
    }

    if (html ?? containsHtmlTags(content)) {
        options.html = true;
    }

    return options;
}

export function normalizeTooltipValue(value) {
    if (!value) {
        return value;
    }

    if (typeof value === 'string') {
        return tooltipBinding(value);
    }

    if (typeof value === 'object' && value.content != null && !('html' in value)) {
        const content = String(value.content);

        if (containsHtmlTags(content)) {
            return {
                ...value,
                html: true,
            };
        }
    }

    return value;
}
